





























































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST, API_URL } from "../global";
import { pageData } from "@/store/pageData";
import { FETCH_PAGE_BY_ID } from "../store/actions.names";
import axios from "axios";
import { URLJoin } from "../utils/common";
import { TimelineMax,Expo, TweenLite, TweenMax, Power2, Power3, Power1 } from "gsap";
@Component({
  name: "JobDetailsPage"
})
export default class JobDetailsPage extends Vue {
  @Prop() public pageData!: pageDataType;
  public HOST: string = HOST;
  URLJoin = URLJoin;
  metaInfo() {
    return {
      title: this.pageData.title,
      meta: [
        {
          vmid: "keyword",
          name: "keyword",
          content: this.pageData.title,
        },
        {
          vmid: "description",
          name: "description",
          content: this.pageData.location,
        },
        // Open Graph / Facebook
        { vmid: "og:type", name: "og:type", content: "website" },
        {
          vmid: "og:url",
          name: "og:url",
          content: process.env.BASE_URL + this.$router.currentRoute.fullPath,
        },
        {
          vmid: "og:site_name",
          name: "og:site_name",
          content: process.env.BASE_URL,
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: this.pageData.location,
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.pageData.description,
        },
        {
          vmid: "og:image",
          name: "og:image",
          content: this.pageData.parent_page.banner_mobile.src,
        },
        //   Twitter
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: this.pageData.description,
        },

        {
          vmid: "twitter:author",
          name: "twitter:author",
          content: "@SQUARE GROUP",
        },
        {
          vmid: "twitter:site",
          name: "twitter:site",
          content: "@SQUARE GROUP",
        },
        {
          vmid: "twitter:creator",
          name: "twitter:creator",
          content: "@SQUARE GROUP",
        },
        {
          vmid: "twitter:url",
          name: "twitter:url",
          content: HOST + this.$route.fullPath,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: this.pageData.sub_company.title,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: this.pageData.description,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: this.pageData.title,
        },
      ],
    };
}
  public heroimganim() {
    var heroimganim = new TimelineMax({});
    heroimganim
      .from(".banner-wrap", 1.3, {
        y: "100%",
        ease: Expo.easeInOut,
        clearProps: "all",
      })
      .from(".banner-wrap img", 0.7, {
        y: 0,
        scale: 1.2,
        ease: Power2.easeInOut,
        clearProps: "all",
      })
      .staggerFrom(
        ".banner-text",
        0.8,
        {
          autoAlpha: 0,
          height: 0,
          ease: Expo.easeInOut,
          clearProps: "all",
        },
        0.01,
        "-=.3"
      )
      .staggerFrom(
        ".banner-text h1",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.5"
      )
      .staggerFrom(
        ".banner-text p",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.6"
      );
  }
  public mounted() {
    this.heroimganim();
  }
}
